import { ApiError } from './ApiError';

export class UnprocessableEntityError extends ApiError {
  constructor(body: any) {
    super(422, body);
  }
}
